// utils/priorities.js

export const DEFAULT_PRIORITIES = [
  { id: "high", value: 3, name: "High", color: "#B01E28" },
  { id: "regular", value: 2, name: "Regular", color: "#FDAB3D" },
  { id: "low", value: 1, name: "Low", color: "#41A300" },
];

export const DEFAULT_PRIORITY_VALUE = 2;

const LEGACY_PRIORITY_VALUES = {
  urgent: 3,
  high: 3,
  normal: 2,
  regular: 2,
  low: 1,
};

export const normalizePriorityValue = (
  priority,
  fallback = DEFAULT_PRIORITY_VALUE,
) => {
  if (typeof priority === "number" && Number.isFinite(priority)) {
    return Math.max(1, Math.round(priority));
  }

  if (
    typeof priority?.value === "number" &&
    Number.isFinite(priority.value)
  ) {
    return Math.max(1, Math.round(priority.value));
  }

  if (Array.isArray(priority)) {
    const activePriority = priority.find((item) => item?.active === true);
    const name = String(activePriority?.name || "").toLowerCase();

    return LEGACY_PRIORITY_VALUES[name] ?? fallback;
  }

  return fallback;
};

export const getPriorityOptions = (priorities) => {
  const validPriorities = Array.isArray(priorities)
    ? priorities.filter(
        (item) =>
          typeof item?.value === "number" &&
          typeof item?.name === "string" &&
          item.name.trim(),
      )
    : [];

  const result =
    validPriorities.length > 0 ? validPriorities : DEFAULT_PRIORITIES;

  return [...result].sort((a, b) => b.value - a.value);
};

export const getPriorityFilterScope = (spaceId, stationId) =>
  JSON.stringify([spaceId || null, stationId || null]);